// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2g81L","filesListContainer":"PosDisputesFiles_filesListContainer__1Nwyx","filesButton":"PosDisputesFiles_filesButton__20Haj"};